var _style, _path, _path2, _defs, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDosbLogoFull(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 285 87.3",
    style: {
      enableBackground: "new 0 0 285 87.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#060000;}\n\t\n\t\t.st1{clip-path:url(#SVGID_00000030461569230810901880000002516739552022808458_);fill:url(#SVGID_00000036252256031948303860000005108669352464986554_);}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.4,42.9c0,6.6-2,12.8-5.6,17.7l1.7,7.7l7.6,1.1c6.3-7.7,9.1-17.4,9.1-26.5l-6.4-4.2L68.4,42.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.3,1.6v82.6h35.9c10.9,0,19.5-2.5,26.2-6.5l-2.1-6l-7.2-3c-4.5,2.3-9.8,3.6-16,3.6H13V13.5L8.5,5.6L0.3,1.6z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M57.2,42.8C57.2,25.8,70.9,12,87.7,12c16.8,0,30.5,13.8,30.5,30.9c0,17.1-13.6,30.9-30.5,30.9 C70.9,73.7,57.2,59.9,57.2,42.8 M44.5,42.9c0,23.7,19.4,42.9,43.3,42.9c23.9,0,43.3-19.2,43.3-42.9C131,19.2,111.6,0,87.7,0 C63.8,0,44.5,19.2,44.5,42.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000022559602534911104760000007283553278047034796_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000125588433753982569600000004077011518931058567_",
    gradientUnits: "userSpaceOnUse",
    x1: -231.3743,
    y1: 614.6665,
    x2: -230.3742,
    y2: 614.6665,
    gradientTransform: "matrix(0 85.7207 85.7207 0 -52601.9062 19833.5742)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#060000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1217,
    style: {
      stopColor: "#060000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1563,
    style: {
      stopColor: "#1F0000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1813,
    style: {
      stopColor: "#390008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.198,
    style: {
      stopColor: "#4D000E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2572,
    style: {
      stopColor: "#8E1528"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3101,
    style: {
      stopColor: "#C1253D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3499,
    style: {
      stopColor: "#E12F49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3719,
    style: {
      stopColor: "#ED334E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6437,
    style: {
      stopColor: "#ED334E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7225,
    style: {
      stopColor: "#F26642"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7927,
    style: {
      stopColor: "#F79737"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8378,
    style: {
      stopColor: "#FBB031"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBB031"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 0,
    style: {
      clipPath: "url(#SVGID_00000022559602534911104760000007283553278047034796_)",
      fill: "url(#SVGID_00000125588433753982569600000004077011518931058567_)"
    },
    width: 86.5,
    height: 85.7
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.1,42.9c0-19.2-12.5-41.3-44.9-41.3H0.3L13,13.5h24.2c19.5,0,31.2,13.1,31.2,29.4H81.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160,47.2c-19.4-1.1-25.4-11.8-25.4-22.8c0-11.2,6.9-22.8,27.3-22.8h40.3l-4.4,11.9l-35.9,0 c-8.8,0-14.5,3.5-14.5,10.9c0,6.5,4.6,10,13.2,10.5l14.8,1c19.7,1.1,27,10.1,27,24c0,13.5-8.9,24.3-29.2,24.3h-43.1l4.4-11.9 l38.9,0c11.6,0,16.1-6,16.1-12.3c0-7.5-5-10.9-14.8-11.7L160,47.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M273.5,41.6c7.1,4.2,10.2,11.5,10.2,18.4c0,13.5-9,24.2-29,24.2h-44.2V1.6h44.7c20.4,0,27.3,11.6,27.3,22.8 C282.5,31.1,278.5,38.5,273.5,41.6 M255.1,72.2c11,0,15.9-5.5,15.9-12.3s-4.6-12.3-15.3-12.3h-32.4v24.6H255.1z M255.6,35.7 c9.3,0,14.2-4.3,14.2-11.1c0-7.3-6.1-11.1-14.5-11.1h-31.9v22.1H255.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDosbLogoFull);
export default __webpack_public_path__ + "static/media/dosb-logo-full.98d06cee12a6e8776f6cd488c692fed2.svg";
export { ForwardRef as ReactComponent };